import { createSlice } from "@reduxjs/toolkit";
import { postRequest } from "../../services/apiCaller/cl_index";
import { endpoints } from "../../api/ApiEndPoints";
import { removeFromLocalStorage, trackEvent } from "../../services/helper/cl_Helper";

const initialState = {
    changePinStatus: false,
    isLoggedOut: false,
    validationError: "",
    isLoading: false
};

export const changePinSlice = createSlice({
    name: "changepin",
    initialState,
    reducers: {
        setChangePinStatus: (state, action) => {
            state.changePinStatus = action.payload;
        },
        setIsLoggedOut: (state, action) => {
            state.isLoggedOut = action.payload;
        },
        setValidationError: (state, action) => {
            state.validationError = action.payload;
        },
        setIsLoading: (state, action) => {
            state.isLoading = action.payload;
        }
    },
});

export const { setChangePinStatus, setIsLoggedOut, setValidationError, setIsLoading } =
    changePinSlice.actions;
export default changePinSlice.reducer;

export const handleChangePin = (newPin, oldPin, accessToken, navigate) => (dispatch) => {
    dispatch(setIsLoading(true));
    let url = endpoints.changePin;
    const payload = {
        accessToken: accessToken,
        channelType: "mobile",
        newPassword: newPin,
        oldPassword: oldPin,
    };

    postRequest(url, payload).then((res) => {
        dispatch(setIsLoading(false));
        if (res?.data.result.status === 200) {
            dispatch(setChangePinStatus(true));
        } else {
            if (res?.data.result.message === "PASSWORD_VALIDATION_FAILED") {
                dispatch(setValidationError("PASSWORD_VALIDATION_FAILED"));
            }
            dispatch(setChangePinStatus(false));
        }
    }).catch(() => {
        dispatch(setIsLoading(false));
    });
};
export const handleLogout = (accessToken, navigate) => (dispatch) => {
    let url = endpoints.logout;
    const payload = {
        accessToken: accessToken,
        channelType: "mobile",
    };

    postRequest(url, payload).then((res) => {
        console.log(res?.data?.result?.message);
        if (res?.data?.result?.status === 200 || res?.data?.statusCode===401) {
            dispatch(setIsLoggedOut(true));
            dispatch(setChangePinStatus(false));
            trackEvent('User', 'pin change', 'success');
            
            // Save chat history before clearing localStorage
            const chatKeys = Object.keys(localStorage).filter(key => key.startsWith('fasfas_chat_history_'));
            const chatData = {};
            chatKeys.forEach(key => {
                chatData[key] = localStorage.getItem(key);
            });
            
            // Clear localStorage
            localStorage.clear();
            
            // Restore chat history
            Object.keys(chatData).forEach(key => {
                localStorage.setItem(key, chatData[key]);
            });
            
            window.location.href="/";
        } else {
            dispatch(setIsLoggedOut(false));
        }
    });
};
